// Challenge to the reader: find a shorter v4 UUID function
function uuid(a = undefined) {
    return a
        ? (a ^ ((Math.random() * 16) >> (a / 4))).toString(16)
        : (([1e7] as any) + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
}

/**
 * A complete v4 UUID
 */
export function generateUUID() {
    return uuid();
}

/**
 * A six character random ID
 */
export function generateShortUID() {
    return (
        ('000' + ((Math.random() * 46656) | 0).toString(36)).slice(-3) +
        ('000' + ((Math.random() * 46656) | 0).toString(36)).slice(-3)
    );
}
